export const mixins = {
    methods: {
        addToCache: function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
        getFromCache: function (key) {
            try{
                return JSON.parse(localStorage.getItem(key));
            }catch(err){
                return null;
            }
        },
        addToSessions: function (key, value) {
            sessionStorage.setItem(key, JSON.stringify(value));
        },
        getFromSessions: function (key) {
            try{
                return JSON.parse(sessionStorage.getItem(key));
            }catch(err){
                return null;
            }
        },
        selectSomeProperties(data, mappedData) {
            Object.keys(mappedData).filter(key => key != 'packages' && key != 'FullName').forEach(key => {

                if (data.hasOwnProperty(key)) mappedData[key] = data[key];
            })
            Object.keys(mappedData.packages[0]).forEach(key => {
                if (data.hasOwnProperty(key)) mappedData.packages[0][key] = data[key];
            })


        },
        filterValidQueries(queryObject) {
            return Object.fromEntries(
            Object.entries(queryObject).filter(([key, value]) => value !== null && value !== undefined && value !== '')
            );
        },
        getQuery(data){
            if(Object.keys(data).length == 0){
                return;
            }
            const validQueries = this.filterValidQueries({
                fullname: data?.fullname || '',
                phonenumber: data?.phonenumber || '',
                locationid: data?.locationid || '',
                districtid: data?.districtid || '',
                wardid: data?.wardid || '',
                utm_source: data?.utm_source || '',
                utm_medium: data?.utm_medium || '',
                utm_campaign: data?.utm_campaign || '',
                guestid: data?.guestid || ''
            });
            const mergedQueries = {
            ...this.$route.query,
            ...validQueries
            };
            return mergedQueries
        },
        getUTM() {
            const dataQuery = this.$route.query;
            if (dataQuery.length != 0) {
                const campData = [
                    'utm_source',
                    'utm_medium',
                    'utm_campaign',
                    'utm_term',
                    'utm_content'
                ]
                for (let e of campData) {
                    if (dataQuery[e]) {
                        sessionStorage[e] = dataQuery[e] || ''
                    }
                }
            }
        }
    }
}
